import { render, staticRenderFns } from "./cvc.vue?vue&type=template&id=10921719&"
import script from "./cvc.vue?vue&type=script&lang=ts&"
export * from "./cvc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports